// The first-run cards, generated from .appfactory/product-plan.json.
//
// Written by `appfactory product apply`: who the app is for (the main flow's
// opening moment), what it does for them, and — when growth/positioning.json
// ranks one — the proof. Each card shows a real capture of the screen it talks
// about, made by `appfactory build` into public/onboarding/. A card whose
// capture does not exist yet shows its icon instead, so this is never blank.
//
// Edit the PLAN and re-apply rather than editing here. Edit it and it is yours:
// the next apply leaves it alone.

import { carSportOutline, flagOutline, constructOutline } from 'ionicons/icons';

const shot = (screen) => `${import.meta.env.BASE_URL}onboarding/${screen}.png`;

export const ONBOARDING = {
  // A SMALL NUMBER, on purpose: QA and the screenshot pass mark
  // `onboarding.v0`…`v7` as seen before the app boots. Bump it by hand when
  // the cards change enough that everyone should see them again.
  version: 1,
  finishLabel: 'To the grid',
  cards: [
    {
      title: 'One car, one lap of Marina Bay',
      body: 'You start at the back of the grid in the red Lamborghini Huracan, with five rivals ahead.',
      img: shot('grid'),
      shot: true,
      icon: carSportOutline,
    },
    {
      title: 'Drive from inside the car',
      body: 'When the lights go out, steer with the arrows and brake for the hairpins. Win and the champagne comes out.',
      img: shot('drive'),
      shot: true,
      icon: flagOutline,
    },
    {
      title: 'More cars and the pit lane are next',
      body: 'The garage shows what is coming: more cars to choose from, and pit stops for new tyres.',
      img: shot('garage'),
      shot: true,
      icon: constructOutline,
    },
  ],
};
